export default {"src":"/polygon/_next/static/media/balancer.6b298a1c.svg","height":48,"width":48};